import React from "react";
import BaseComponent from "../BaseComponent";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import NanoFlex from "../Global/NanoFlex.js";
import cardService from "../../services/CardService";
import playlistService from "../../services/PlaylistService";

import Spinner from "../Nano/Spinner.js";
import Type from "../Global/Typography.js";
import TitleCard from "../Nano/TitleCard.js";
import Image from "../Nano/Image.js";

//IMAGES
import { ReactComponent as Playlist } from "../Global/Icons/playlist.svg";
import { ReactComponent as UpcomingProgrammes } from "../Global/Icons/upcomingProgrammes.svg";
import { ReactComponent as NotaSelectionLabel } from "../Global/Icons/label.svg";
const multiple = nota.global.multiple;

const StyledLoading = styled(NanoFlex)`
  width: 350px;
  min-height: 404.83px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: 2px solid ${nota.color.neutral.NeuFive};
  background-color: ${nota.color.neutral.white};
  /* position: absolute; */
  z-index: 99;
`;

const BiggerThumbHoverStyle = styled.div`
  /* position: absolute; */
  z-index: 99;
  width: 350px;
  padding: ${multiple * 2 + "px"};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border: 2px solid ${nota.color.neutral.NeuFive};
  background-color: ${nota.color.neutral.white};
  .blockContainer {
    padding: ${multiple + "px"} 0 ${multiple * 2 + "px"} 0;
    border-bottom: 1px solid ${nota.color.neutral.NeuFive};
    /* IMG WRAPPER */
    .imgWrapper {
      width: 100%;
      position: relative;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      svg {
        width: 100%;
        height: 100%;
      }
      .selectThumbContainer {
        display: none !important;
      }
      .labelWrapper {
        width: auto;
        height: auto;
        position: absolute;
        bottom: 15%;
        right: 0;
        .labelContainer {
          svg {
            width: 46px;
            height: auto;
            -webkit-filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
            filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
          }
        }
      }
    }
    /* END IMG WRAPPER */

    /* INFO CARD */
    .infoCard {
      overflow: hidden;
      .mainWrapper {
        h3 {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
        }
        .secTitlesCardWrapper {
          .secTitlesCard {
            width: auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            h4 {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 14px;
            }
            &:before {
              content: "/";
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 10px;
              margin: 5px ${multiple + "px"} 0 ${multiple + "px"};
              color: ${nota.color.main.default};
            }
            &:first-child {
              &:before {
                display: none;
              }
            }
          }
        }
      }
      .secInfo {
        margin-top: ${multiple + "px"};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .iconWrapper {
      width: 60px;
      padding: ${multiple * 2 + "px"};
      cursor: pointer;
      svg {
        width: 100%;
        height: auto;
        path {
          fill: ${nota.color.neutral.NeuOne};
        }
      }
      /* &:hover {
        opacity: 0.7;
      } */
    }
    .activeIcon {
      svg {
        width: 100%;
        height: auto;
        path {
          fill: ${nota.color.main.default};
        }
      }
    }
    /* END INFO CARD */

    /* BOTTOM INFO */
    .asideInfoLeft {
      margin-right: ${multiple * 2 + "px"};
      max-width: 128px;
      .titleContainer {
        margin-left: 0px;
        width: auto;
        display: flex;
        .titleWrapper {
          .primaryTitleWrapper {
            margin-right: 0;
            display: flex;
          }
        }
      }
      .launchInfoWrapper {
        margin-top: ${multiple / 2 + "px"};
        p {
          color: ${(props) => (props.isPreview ? nota.color.main.mOne : nota.color.main.default)};
          text-transform: uppercase;
          font-size: 12px;
        }
        .bckInfoWrapper {
          background-color: ${(props) => (props.isPreview ? nota.color.main.mOne : nota.color.main.default)};
          padding: ${multiple / 2 + "px"};
          justify-content: ${(props) => (props.isPreview ? `center` : `flex-start`)};
          h3 {
            font-size: 14px;
            width: 100%;
            color: ${nota.color.neutral.white};
            line-height: inherit;
          }
          .icon {
            display: ${(props) => (props.isPreview ? `flex` : `none`)};
            width: auto;
            svg {
              width: 16px;
              height: 16px;
              path {
                fill: ${nota.color.neutral.white};
              }
            }
          }
        }
      }
    }
    .asideInfoRight {
      height: auto;
      .formatBlock {
        padding: ${multiple + "px"};
        background-color: ${nota.color.neutral.lightGrey};
        margin-bottom: ${multiple / 2 + "px"};
        height: 33px;
        h4 {
          font-size: 12px;
          line-height: normal;
          text-transform: uppercase;
        }
      }
    }
    /* END BOTTOM INFO */

    &:first-child {
      padding: 0;
      border-bottom: 0;
    }
    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
    }
  }
`;

export class BiggerThumbHover extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = this.getDefaultState();
  }

  getDefaultState = () => {
    return {
      card: null,
      imageError: false,
      isPlaylistActive: null,
    };
  };

  isDataLoaded = () => {
    return this.state.card !== null && this.state.isPlaylistActive !== null;
  };

  componentDidMount() {
    if (this.props.isVisible) {
      this.getComponentData();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isVisible !== this.props.isVisible && this.isDataLoaded() === false) {
      this.getComponentData();
    }
  }

  getComponentData = () => {
    this.getCard();
    this.getPlaylists();
  };

  getCard = () => {
    cardService
      .getCard(this.props.id, false)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ card: data });
      });
  };

  getPlaylists = () => {
    playlistService
      .getPlaylistsCountByProgram(this.props.id)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ isPlaylistActive: data > 0 });
      });
  };

  render() {
    if (this.isDataLoaded() === false) {
      return (
        <StyledLoading className="loadingContainer">
          <Spinner />
        </StyledLoading>
      );
    }

    return (
      <BiggerThumbHoverStyle isPreview={this.state.card.isPreview}>
        <NanoFlex className="blockContainer">
          <NanoFlex className="imgWrapper">
            {!this.state.imageError && (
              <Image
                imageUrl={this.state.card.image}
                alt={"Default Card"}
                onError={(error) => {
                  this.setState({ imageError: error });
                }}
              />
            )}
            {this.state.card.isNotaSelection && (
              <NanoFlex className="labelWrapper">
                <NanoFlex className="labelContainer">
                  <NotaSelectionLabel />
                </NanoFlex>
              </NanoFlex>
            )}
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="blockContainer">
          <NanoFlex className="infoCard" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
            <NanoFlex className="mainWrapper" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
              <Type.h3 title={this.state.card.localTitle}>
                <b>{this.state.card.localTitle}</b>
              </Type.h3>
              <NanoFlex className="secTitlesCardWrapper" justifyContent={"flex-start"} alignItems={"flex-start"}>
                {/* Format Title -> Show When: Different Of Null | Different of Local Title */}
                {this.state.card.formatTitle && this.state.card.formatTitle !== this.state.card.localTitle && (
                  <NanoFlex className="secTitlesCard">
                    <Type.h4 title={this.state.card.formatTitle}>{this.state.card.formatTitle}</Type.h4>
                  </NanoFlex>
                )}
                {/* Original Title -> Show When: Different Of Null | Different of Format Title | Different of Local Title */}
                {this.state.card.originalTitle && this.state.card.originalTitle !== this.state.card.formatTitle && this.state.card.originalTitle !== this.state.card.localTitle && (
                  <NanoFlex className="secTitlesCard">
                    <Type.h4 title={this.state.card.originalTitle}>{this.state.card.originalTitle}</Type.h4>
                  </NanoFlex>
                )}
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="secInfo" justifyContent={"flex-start"} alignItems={"flex-start"}>
              <Type.p>
                <b>
                  <em>{this.state.card.genre}</em> / {this.state.card.subGenre}
                </b>
              </Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className={`iconWrapper ${this.state.isPlaylistActive ? "activeIcon" : ""}`}>
            <Playlist />
          </NanoFlex>
        </NanoFlex>
        <NanoFlex className="blockContainer" justifyContent={"flex-start"} alignItems={"stretch"} alignContent={"stretch"}>
          <NanoFlex className="asideInfoLeft" flexDirection={"column"} alignItems={"stretch"}>
            <TitleCard darkTitle={this.state.card.country} />
            <NanoFlex className="channelWrapper" flexDirection={"column"} alignItems={"flex-start"} justifyContent={"flex-start"}>
              <Type.p>
                <em>{this.state.card.channel}</em>
              </Type.p>
              <Type.p>{this.state.card.platform}</Type.p>
            </NanoFlex>
            <NanoFlex className="launchInfoWrapper" flexDirection={"column"} alignItems={"flex-start"}>
              <Type.p>
                <b>{this.translation.card.date}</b>
              </Type.p>
              <NanoFlex className="bckInfoWrapper" alignItems={"center"} justifyContent={"flex-start"}>
                <Type.h3>
                  <b>{this.state.card.date}</b>
                </Type.h3>
                <NanoFlex className="icon" lignItems={"flex-end"} justifyContent={"flex-end"} title={this.translation.navBar.upcomingProgrammes}>
                  <UpcomingProgrammes />
                </NanoFlex>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="asideInfoRight" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"stretch"}>
            <NanoFlex className="formatBlock">
              <Type.h4>
                <b>{this.translation.geral.formatTypes[this.state.card.formatType?.toLowerCase()]}</b>
              </Type.h4>
            </NanoFlex>

            {this.state.card.distributors && (
              <NanoFlex className="infoContainer" flexDirection={"column"} alignItems={"flex-start"}>
                <Type.p className="titleInfo">DISTRIBUTOR(S)</Type.p>
                {this.state.card.distributors.split(" / ").map((item, i) => {
                  return (
                    <Type.p key={"Distributors_" + i}>
                      <b>{item}</b>
                    </Type.p>
                  );
                })}
              </NanoFlex>
            )}
          </NanoFlex>
        </NanoFlex>
      </BiggerThumbHoverStyle>
    );
  }
}

export default BiggerThumbHover;

/*
  Doc
  import BiggerThumbHover from '../../Micro/BiggerThumbHover.js';

  <BiggerThumbHover />
  */
